<div class="dialog-wrapper">
    <header class="dialog-header">
      <h3 class="header-heading">{{ 'pages.userFamily.list.heading.add' | translate }}</h3>
      <button class="close-button" (click)="closeDialog()"></button>
    </header>
  
    <div class="dialog-content">
      <div *ngIf="instructions">
        <h3>Instructions</h3>
        <article class="instructions button-message article-mb quill-content-wrapper ql-editor" 
          [innerHTML]="instructions | safeHtml">
        </article>
      </div>
      <form [formGroup]="addFamilyMemberForm">
        <app-form-input label="{{ 'pages.userFamily.profile.fields.firstName' | translate }}" formControlName="firstName" data-cy="firstName">
          <app-form-error *ngIf="firstName.touched && firstName.hasError('required')">
            {{ 'pages.userFamily.profile.errors.invalidFirstName' | translate }}
          </app-form-error>
        </app-form-input>
  
        <app-form-input label="{{ 'pages.userFamily.profile.fields.lastName' | translate }}" formControlName="lastName" data-cy="lastName">
          <app-form-error *ngIf="lastName.touched && lastName.hasError('required')">
            {{ 'pages.userFamily.profile.errors.invalidLastName' | translate }}
          </app-form-error>
        </app-form-input>
  
        <app-form-datepicker 
          label="{{'pages.userFamily.profile.fields.birthdate' | translate }}"
          [max]="maxDate"
          formControlName="birthDate"
          data-cy="birthDate">
          <app-form-error *ngIf="birthDate.touched && birthDate.hasError('required')">
            {{'pages.userFamily.profile.errors.invalidBirthDate' | translate }}
          </app-form-error>
        </app-form-datepicker>
  
        <app-form-input class="span" type="email" label="{{ 'pages.userFamily.profile.fields.email' | translate }}" formControlName="email" data-cy="email">
          <app-form-error *ngIf="email.touched && (email.hasError('email') || email.hasError('required'))">
            {{ 'pages.userFamily.profile.errors.invalidEmail' | translate }}
          </app-form-error>
          <app-form-error *ngIf="email.touched && (email.hasError('sameEmail'))">
            {{ 'pages.userFamily.error.familySameEmail' | translate }}
          </app-form-error>
        </app-form-input>
  
        <app-user-family-select 
          controlName="link"
          [label]="'pages.userFamily.link.label' | translate" 
          [placeholder]="'pages.userFamily.link.placeholder' | translate" 
          [form]="addFamilyMemberForm"
          [options]="familyLinks" 
          (selectChange)="linkChange($event)" 
        ></app-user-family-select>
  
        <!-- <div class=mtl>
          <label class="dropzone" dragAndDrop (fileDropped)="onFileDropped($event)">
            <input 
              type="file" 
              #fileDropRef 
              [multiple]="options.multiple" 
              (change)="fileBrowseHandler($event.target.files)"
            />
            <h3 class="drag-drop-body">{{ 'pages.userFamily.create.attachments.placeholder' | translate }}</h3>
          </label>
          <div class="info">
            <div class="restriction">
              {{ 'pages.userFamily.create.attachments.requiredNumber' | translate: {number: minimumProofOfIdentity} }}
            </div>
            <div class="restriction" *ngIf="tooManyFiles">
              {{ 'pages.userFamily.create.attachments.tooManyFiles' | translate: {number: allCoreConfig.maximumFileAttachments} }}
            </div>
            <span *ngIf="options.restrictionMessage">
              {{options.restrictionMessage}}
            </span>
          </div>
        </div>
  
        <div class="mtl uploaded-images">
          <h5>{{ 'pages.userFamily.create.attachments.uploads' | translate }}</h5>
          <div class="images-container">
            <div *ngFor="let image of proofOfIdentity.value; let i = index" class="image" [ngStyle]="{'background-image': 'url(' + image +')'}">
              <button class="remove-file" (click)="removeNewFile(i)"><span class="icon-close"></span></button>
            </div>
            <div *ngIf="numFilesLoading > numFilesLoaded" class="image upload-spinner">
              <mat-progress-spinner 
                diameter="50" 
                mode="indeterminate"
              ></mat-progress-spinner>
            </div>
          </div>
        </div> -->
      </form>
    </div>
  
    <footer class="dialog-footer">
      <button 
        class="bciti-button" 
        [ngClass]="!addFamilyMemberForm.valid || processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'" 
        [disabled]="!addFamilyMemberForm.valid || processingSubmit"
        (click)="submit()"
      >
        <span *ngIf="!processingSubmit">{{ 'pages.userFamily.button.submit' | translate }}</span>
        <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner>
      </button>
    </footer>
  </div>
  